module.exports = __webpack_public_path__ + "img/enemy_124_004.23ab7655.png";